import makeStyles from "@mui/styles/makeStyles";
import { RequirementListProps } from "./RequirementList.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
  },
  item: {
    display: "flex",
    flex: (props: RequirementListProps) =>
      props.itemWidth ? `0 0 ${props.itemWidth}` : "0 0 50%",
    minHeight: 24,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 4,
  },
  iconSuccess: {
    color: theme.palette.primary.main,
  },
  iconError: {
    color: theme.palette.error.main,
  },
}));
